module.exports = __webpack_public_path__ + "static/media/blom-pysanky-sm-66.a5934097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-sm-66.jpg
// module id = 3891
// module chunks = 13